import { createContext } from 'react'

export interface KcRegistryValue {
  register: (kcId: string) => void
}

export const KcRegistryContext = createContext<KcRegistryValue | null>(null)
